import React from "react";

/**
 * DS LangTag — figma 269:178 "Langauge-button" (typo: Language)
 *
 * default state: white bg + border default, radius 999, padding pl=6 pr=12 py=6, gap 8
 *   - badge: BG/Paper pill (padding 6×4, radius 999), "+ EN" Pretendard SemiBold 10/14 Tertiary
 *   - label: "English" Pretendard Regular 12/18 Tertiary
 *
 * suspect: active 상태 (선택됨) 디자인은 노드 fetch 안 함. 우선 default만 구현.
 *          input 시안에서 활성화된 EN 태그가 있어 추후 확인 필요.
 *
 * @param {object} props
 * @param {"EN"|"JP"|"CN"} props.code
 * @param {string} props.label - "English" / "日本語" / "中文"
 * @param {boolean} [props.active] - 선택 여부
 * @param {() => void} [props.onClick]
 */
const DSLangTag = ({ code, label, active = false, onClick }) => {
  return (
    <button
      type="button"
      className={`ds-lang-tag ${active ? "ds-lang-tag--active" : ""}`}
      onClick={onClick}
    >
      <span className="ds-lang-tag__badge">{active ? code : `+ ${code}`}</span>
      <span className="ds-lang-tag__label">{label}</span>
    </button>
  );
};

export default React.memo(DSLangTag);
